import "swiper/css";
import "swiper/css/pagination";

import { normalize } from "polished";
import { createGlobalStyle } from "styled-components";

import { theme } from "./theme";

export const GlobalStyles = createGlobalStyle`
  ${normalize()};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    font-family: 'Readex Pro', 'Arial', sans-serif;
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${theme.colors.black};
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
    font: inherit;
    font-size: 100%;
  }

  a {
    color: inherit;
  }

  button {
    font-family: inherit;
    line-height: normal;
    border-radius: 0;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
  }

  input {
    font-family: inherit;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
  }

  ul, ol {
    padding-left: 0;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none
  }
`;
